import React from 'react';
import { Outlet } from 'react-router-dom';
import { SocialProvider } from '../../contexts/SocialContext';
import SocialLayout from './SocialLayout';

export default function SocialHome() {
  return (
    <SocialProvider>
      <SocialLayout>
        <Outlet />
      </SocialLayout>
    </SocialProvider>
  );
}
